import React from 'react';

export default function buildSvg (iconData: Array<object>): Array<any> {
    const svgElements: Array<any>= iconData.map((prop: any, index: number) => {
        // rename class key if it exists in prop.attributes to className as it throws an err in React
        // slight concern here mutating the obj coming in, but doesn't seem to cause an issue
        const safeAttrs = prop.attributes;
        if (safeAttrs.class) {
            safeAttrs.className = safeAttrs.class;
            delete safeAttrs.class;
        }

        const overrideConfig = {
            fill: (safeAttrs.fill === 'none') ? safeAttrs.fill : '',
            stroke: (safeAttrs.stroke === 'transparent') ? safeAttrs.stroke : ''
        };
        const mergedConfig = { ...safeAttrs, ...overrideConfig  };

        if (prop.name === 'path') {
            return <path {...mergedConfig} key={`path-${index}`} />;
        } else if (prop.name === 'circle') {
            return <circle {...safeAttrs} key={`circle-${index}`} />;
        } else if (prop.name === 'g') {
            return (
                <g {...safeAttrs} key={`g-${index}`} >
                    {buildSvg(prop.children)}
                </g>
            );
        } else if (prop.name === 'rect') {
            return <rect {...safeAttrs} fill='' key={`rect-${index}`} />;
        } else {
            return null;
        }
    });
    return svgElements;
};
